<template>
    <div class="half" :class="{ whatPage: page == 'what' }"></div>
    <div class="what_container" v-if="page == 'what'">
        <div class="inside-what">
            <div class="left-container">
                <div class="left">
                    <div
                        class="nav swiper-button-next"
                        @click="swiperInstance.slideNext()"
                    >
                        <img src="@/assets/images/nav-up.webp" alt="" />
                    </div>
                    <swiper
                        :direction="'vertical'"
                        :slides-per-view="1"
                        :space-between="50"
                        :loop="true"
                        @swiper="onSwiper"
                        @slideChange="onSlideChange"
                    >
                        <swiper-slide v-for="stack in stacks" :key="stack.tab">
                            <img :src="stack.img" alt="" />
                        </swiper-slide>
                    </swiper>
                    <div
                        class="nav swiper-button-prev"
                        @click="swiperInstance.slidePrev()"
                    >
                        <img
                            src="@/assets/images/nav-up.webp"
                            alt=""
                            style="rotate: 180deg"
                        />
                    </div>
                </div>
                <transition name="bounce" mode="out-in">
                    <div class="desc">
                        <h1>{{activeStack.title}}</h1>
                        <p>
                            {{activeStack.desc}}
                        </p>
                    </div>
                </transition>
            </div>
            <div class="right">
                <div class="right-content">
                    <h1>
                        Core <br />
                        Competencies
                    </h1>
                    <p>
                        Here are the technologies that i acquired during my
                        working experiences and also in my free time studying.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, Navigation } from "swiper/vue";
import "swiper/css";
import { ref } from "vue";

export default {
    props: ["page"],
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        const swiperInstance = ref();
        const onSwiper = (swiper) => {
            swiperInstance.value = swiper;
            console.log(swiperInstance.value);
        };
        const activeStack = ref({});

        const stacks = [
            {
                title: "VUE JS",
                desc: "Vue (pronounced /vjuː/, like view) is a JavaScript framework for building user interfaces. It builds on top of standard HTML, CSS, and JavaScript and provides a declarative, component-based programming model that helps you efficiently develop user interfaces of any complexity.",
                img: require("@/assets/images/sliders/vue.webp"),
                tab: 0,
            },
            {
                title: "React",
                desc: "React (also known as React.js or ReactJS) is a free and open-source front-end JavaScript library for building user interfaces based on components. It is maintained by Meta (formerly Facebook) and a community of individual developers and companies.",
                tab: 1,
                img: require("@/assets/images/sliders/react.svg"),
            },
            {
                title: "React Native",
                desc: "React Native is an open-source UI software framework created by Meta Platforms, Inc. It is used to develop applications for Android, Android TV, iOS, macOS, tvOS, Web, Windows and UWP by enabling developers to use the React framework along with native platform capabilities.",
                tab: 2,
                img: require("@/assets/images/sliders/react_native.svg"),
            },
            {
                title: "HTML",
                desc: "HyperText Markup Language or HTML is the standard markup language for documents designed to be displayed in a web browser. It defines the content and structure of web content.",
                tab: 3,
                img: require("@/assets/images/sliders/html.webp"),
            },
            {
                title: "CSS",
                desc: "Cascading Style Sheets (CSS) is a style sheet language used for specifying the presentation and styling of a document written in a markup language such as HTML or XML (including XML dialects such as SVG, MathML or XHTML).",
                tab: 4,
                img: require("@/assets/images/sliders/css.webp"),
            },
            {
                title: "Javascript",
                desc: "JavaScript (JS) is a popular programming language used to create dynamic and interactive web content. It is primarily used on the client-side (in the user’s web browser) to enhance web pages and applications.",
                tab: 5,
                img: require("@/assets/images/sliders/js.webp"),
            },
            {
                title: "Laravel",
                desc: "Laravel is a free and open-source PHP- based web framework for building high-end web applications. It was created by Taylor Otwell and intended for the development of web applications following the model–view–controller (MVC) architectural pattern and based on Symfony",
                tab: 6,
                img: require("@/assets/images/sliders/lara.webp"),
            },
            {
                title: "Bootstrap",
                desc: "Bootstrap (formerly Twitter Bootstrap) is a free and open-source CSS framework directed at responsive, mobile-first front-end web development. It contains HTML, CSS and (optionally) JavaScript-based design templates for typography, forms, buttons, navigation, and other interface components.",
                tab: 7,
                img: require("@/assets/images/sliders/bs.webp"),
            },
            {
                title: "Adobe Photoshop",
                desc: "Adobe Photoshop is a raster graphics editor developed and published by Adobe for Windows and macOS. It was originally created in 1987 by Thomas and John Knoll. Since then, the software has become the most used tool for professional digital art, especially in raster graphics editing.",
                tab: 8,
                img: require("@/assets/images/sliders/ps.webp"),
            },
            {
                title: "SASS",
                desc: "Sass (short for syntactically awesome style sheets) is a preprocessor scripting language that is interpreted or compiled into Cascading Style Sheets (CSS). SassScript is the scripting language itself. Sass consists of two syntaxes.",
                tab: 9,
                img: require("@/assets/images/sliders/sass.webp"),
            },
            {
                title: "Figma",
                desc: "Figma is a collaborative web application for interface design, with additional offline features enabled by desktop applications for macOS and Windows. The feature set of Figma focuses on user interface and user experience design, with an emphasis on real-time collaboration, utilising a variety of vector graphics editor and prototyping tools. ",
                tab: 10,
                img: require("@/assets/images/sliders/figma.webp"),
            },
            {
                title: "PHP",
                desc: "PHP is a general-purpose scripting language geared towards web development. It was originally created by Danish-Canadian programmer Rasmus Lerdorf in 1993 and released in 1995. The PHP reference implementation is now produced by the PHP Group. ",
                tab: 11,
                img: require("@/assets/images/sliders/php.webp"),
            },
            {
                title: "GIT",
                desc: "Git (/ɡɪt/) is a distributed version control system that tracks changes in any set of computer files, usually used for coordinating work among programmers who are collaboratively developing source code during software development. ",
                tab: 12,
                img: require("@/assets/images/sliders/git.webp"),
            },
            {
                title: "Axios",
                desc: "Axios (stylized as ΛXIOS) is an American news website based in Arlington, Virginia. It was founded in 2016 and launched the following year by former Politico journalists Jim VandeHei, Mike Allen, and Roy Schwartz. ",
                tab: 13,
                img: require("@/assets/images/sliders/axios.svg"),
            },
        ];

        const onSlideChange = (event) => {
            console.log(event);
            activeStack.value = stacks[event.realIndex]
        };
        return {
            onSwiper,
            swiperInstance,
            modules: [Navigation],
            activeStack,
            stacks,
            onSlideChange,
        };
    },
};
</script>

<style lang="scss" scoped>
.half {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 0;
    background: url("../../assets/images/bg-2.webp") no-repeat;
    transition: 0.3s;
    transition-delay: 0.3s;
}
.whatPage {
    width: 44%;
}
.what_container {
    background: #04293a;
    height: 87vh;

    .inside-what {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        .left-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1;
            .left {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                .nav {
                    cursor: pointer;
                }
                .swiper {
                    width: 500px;
                    height: 450px;
                    margin: 0;
                }

                .swiper-slide {
                    text-align: center;
                    font-size: 18px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .swiper-slide img {
                    display: block;
                    height: auto;
                    object-fit: cover;
                }
            }
            .desc {
                width: 500px;
                text-align: center;
                border: 2px solid #ecb365;
                border-radius: 20px;
                background: #041c32;
                padding: 20px 30px;
                box-shadow: 2px 20px 50px #000;
                h1 {
                    color: #ecb365;
                }
                p {
                    color: #fff;
                }
            }
        }
        .right {
            flex: 1;
            z-index: 999;
            width: 100%;
            display: flex;
            justify-content: center;
            .right-content {
                width: 650px;
                margin: 70px;
                h1 {
                    font-size: 50px;
                    font-weight: bolder;
                    color: #ecb365;
                    text-align: right;
                }
                p {
                    font-size: 30px;
                    color: #fff;
                    text-align: right;
                    font-weight: lighter;
                }
            }
        }
    }
}
</style>
